import { Link } from "react-router-dom";

export default function MobileBottomMenu({ Page }) {
  return (
    <>
      {" "}
      <nav className="bottom-nav">
        <Link
          to="/dashboard"
          className={Page == "Dashboard" ? "nav-item active" : "nav-item"}
          data-page="dashboard"
        >
          <div className="nav-icon-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3.04333C12.0932 3.04333 12.1786 3.07243 12.2422 3.11853L21.1309 9.56677C21.1738 9.59796 21.2037 9.63506 21.2227 9.67126C21.2413 9.70705 21.25 9.74314 21.25 9.77771V20.6703C21.25 20.7287 21.2257 20.7965 21.1631 20.8549C21.0987 20.9149 21.0006 20.9564 20.8887 20.9564H3.11133C2.99938 20.9564 2.90127 20.9149 2.83691 20.8549C2.77433 20.7965 2.75 20.7287 2.75 20.6703V9.77771C2.75001 9.74314 2.75865 9.70705 2.77734 9.67126C2.79631 9.63506 2.82619 9.59796 2.86914 9.56677L11.7578 3.11853C11.8213 3.07243 11.9068 3.04333 12 3.04333ZM10.1387 20.3842H13.8613V12.6664H10.1387V20.3842Z"
                stroke="white"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <span className="nav-text">Home</span>
        </Link>
        <Link
          to="/Attendance"
          className={Page == "Attendance" ? "nav-item active" : "nav-item"}
          data-page="attendance"
        >
          <div className="nav-icon-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2V9L14 7"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 9L10 7"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.97998 13H6.38998C6.76998 13 7.10998 13.21 7.27998 13.55L8.44998 15.89C8.78998 16.57 9.47998 17 10.24 17H13.77C14.53 17 15.22 16.57 15.56 15.89L16.73 13.55C16.9 13.21 17.25 13 17.62 13H21.98"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 4.12988C3.46 4.64988 2 6.72988 2 10.9999V14.9999C2 19.9999 4 21.9999 9 21.9999H15C20 21.9999 22 19.9999 22 14.9999V10.9999C22 6.72988 20.54 4.64988 17 4.12988"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span className="nav-text">Attendance</span>
        </Link>
        <a
          href="/course-material"
          className={Page == "Materials" ? "nav-item active" : "nav-item"}
          data-page="materials"
        >
          <div className="nav-icon-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3701 8.87988H17.6201"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.37988 8.87988L7.12988 9.62988L9.37988 7.37988"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.3701 15.8799H17.6201"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.37988 15.8799L7.12988 16.6299L9.37988 14.3799"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span className="nav-text">Materials</span>
        </a>
        <a
          href="/academy"
          className={Page == "Academy" ? "nav-item active" : "nav-item"}
          data-page="purchases"
        >
          <div className="nav-icon-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.3148 7.51481L13.7344 3.39001C12.643 2.87 11.3911 2.87 10.2997 3.39001L1.72263 7.51153C1.12238 7.794 0.75 8.38464 0.75 9.04912C0.75 9.71359 1.12236 10.3042 1.71622 10.5867L4.30669 11.8322V17.1991C4.30669 17.6774 4.43829 18.146 4.68547 18.544C4.73683 18.6307 4.78819 18.7045 4.84276 18.7719C5.07067 19.0705 5.36276 19.3144 5.72228 19.5038C7.69002 20.4957 9.85038 20.9932 12.0108 20.9932C14.1712 20.9932 16.3316 20.4957 18.3021 19.5038C18.6552 19.324 18.957 19.0736 19.1977 18.7559C19.538 18.3 19.7177 17.764 19.7177 17.2023V11.8354L21.6726 10.8948V20.1975C21.6726 20.6405 22.0321 21 22.4751 21C22.9181 21 23.2776 20.6405 23.2776 20.1975V9.06189V9.05226V9.04905C23.284 8.38458 22.9119 7.79409 22.3148 7.51481ZM18.1193 17.1992C18.1193 17.4111 18.0487 17.6165 17.9235 17.7866C17.8336 17.9054 17.7181 18.0017 17.5865 18.0691C14.1004 19.8282 9.93713 19.8282 6.46069 18.0723C6.31945 17.9985 6.20389 17.9054 6.12364 17.7931C6.11722 17.7834 6.09475 17.7578 6.08833 17.7481C6.0787 17.7385 6.07228 17.7257 6.06265 17.7096C5.96956 17.5555 5.9182 17.379 5.9182 17.1992V12.6056L10.3031 14.7146C10.8488 14.9746 11.433 15.1062 12.0204 15.1062C12.6079 15.1062 13.1921 14.9746 13.7378 14.7146L18.1227 12.6088V17.1991L18.1193 17.1992ZM21.6214 9.1423L18.5815 10.6029C18.5783 10.6029 18.5783 10.6029 18.5751 10.6061L13.041 13.2672C12.3894 13.5785 11.6415 13.5785 10.993 13.2672L5.4589 10.6061H5.45569L2.4094 9.14231C2.39335 9.13589 2.35483 9.11663 2.35483 9.05243C2.35483 8.98823 2.39335 8.97218 2.41261 8.96255L10.9897 4.83774C11.3139 4.68045 11.6638 4.60341 12.0137 4.60341C12.3636 4.60341 12.7102 4.68045 13.0377 4.83453L21.6242 8.96263C21.6403 8.96905 21.6756 8.98831 21.6788 9.0493V9.05251V9.05572C21.6756 9.1135 21.6342 9.13588 21.6214 9.1423Z"
                fill="white"
              />
            </svg>
          </div>
          <span className="nav-text">Academy</span>
        </a>
        <Link
          to="/live-classes"
          className={Page == "LiveClass" ? "nav-item active" : "nav-item"}
          data-page="liveclass"
        >
          <div className="nav-icon-container">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9116 7.70535C22.2604 7.43889 21.515 7.58878 21.0094 8.07173L18.6617 10.3532V10.0618C18.6617 7.76362 16.7424 5.89844 14.3775 5.89844H4.28417C1.91931 5.89844 0 7.76362 0 10.0618V14.6582C0 16.9563 1.91931 18.8215 4.28417 18.8215H14.3863C16.7512 18.8215 18.6705 16.9563 18.6705 14.6582V14.3667L21.0182 16.6482C21.3524 16.973 21.7979 17.1478 22.2521 17.1478C22.4748 17.1478 22.7062 17.1062 22.9204 17.0146C23.5716 16.7481 24 16.1403 24 15.4492V9.26235C24 8.57122 23.5802 7.96339 22.9204 7.69693L22.9116 7.70535ZM16.9565 14.6582C16.9565 16.0321 15.7998 17.1562 14.386 17.1562H4.2839C2.87013 17.1562 1.71339 16.0321 1.71339 14.6582V10.0619C1.71339 8.68798 2.87013 7.56386 4.2839 7.56386H14.386C15.7998 7.56386 16.9565 8.68798 16.9565 10.0619V14.6582ZM22.2261 15.4742L19.0302 12.3684L22.2777 9.27091L22.2261 15.4742Z"
                fill="white"
              />
            </svg>
          </div>
          <span className="nav-text">Live Classes</span>
        </Link>
      </nav>
    </>
  );
}
